import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron-right\">\n  <polygon fill=\"#677078\" points=\"10 6 8.59 7.41 13.17 12 8.59 16.59 10 18 16 12\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol